import { createEnvConfig } from './createEnvConfig';

// Runtime-configurable environment variables (injectable at Docker startup)
export interface EnvConfig {
  readonly VITE_SESSION_COOKIE: string;
  readonly VITE_AVA_ENV: 'local' | 'develop' | 'staging' | 'uat' | 'alpha' | 'sandbox' | 'prod' | 'test';
  readonly VITE_API_ENDPOINT: string;
  readonly VITE_WS_ENDPOINT: string;
  readonly VITE_MIXPANEL_TOKEN: string;
  readonly VITE_MIXPANEL_PROXY_URL: string;
  readonly VITE_BASE_URL: string;
}

export const envConfig = createEnvConfig<EnvConfig>(import.meta.env);
